import 'css-chunk:src/app/containers/Projects/ProjectsPage/Sidebar/Sidebar.scss';export default {
  "Sidebar": "_Sidebar_99mzm_1",
  "projectPicker": "_projectPicker_99mzm_7",
  "footerMenu": "_footerMenu_99mzm_8",
  "divider": "_divider_99mzm_22",
  "content": "_content_99mzm_26"
};